import { useTranslation } from '@testsigma/atoms';
import sync_started from '@images/sync_stated.svg';

const RefreshMetadataSyncStarted: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center justify-center h-full'>
      <div className='leading-8 font-semibold text-secondary-1000 text-2xl'>
        {t('header.metadata_sync_started')}
      </div>

      <div className='mt-6 mb-8'>
        <img
          src={sync_started}
          className='empty-illustration'
          alt='Tick Illustration'
        />
      </div>

      <div className='flex mb-10 text-center text-sm text-secondary-text'>
        {t('message.metadata_sync_started')}
      </div>
    </div>
  );
};

export { RefreshMetadataSyncStarted };
